import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { setSubscriptionPayment } from 'services/plan'

export default function useSetPayment() {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISetSubscriptionPaymentPayload) => {
            return setSubscriptionPayment(payload)
        },
        onSuccess: (result, variables) => {
            //@ts-ignore
            window.location.replace(result?.transaction.pay_url)
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'subscription',
                    data: [],
                    //@ts-ignore
                    pk: 0,
                    //@ts-ignore
                    gateway: 0,
                })
            )
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
